import { defineComponent as _defineComponent } from 'vue'
import { TUIGlobal } from "@tencentcloud/chat-uikit-engine";
import {
  computed,
  CSSProperties,
  onMounted,
  ref,
  watch,
  defineProps,
} from "../../../adapter-vue";
import TOAST_TYPE from "./type";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  message: {
    type: String,
    default: "",
  },
  duration: {
    type: Number,
    default: 3000,
  },
  repeatNum: {
    type: Number,
    default: 1,
  },
  id: {
    type: String,
    default: "",
  },
  onClose: {
    type: Function,
    required: false,
  },
  offset: {
    type: Number,
    default: 20,
  },
  zIndex: {
    type: Number,
    default: 0,
  },
  type: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props


const visible = ref(false);
const isH5 = ref(TUIGlobal.getPlatform() === "h5");
let timer: any;
const onClose = ref();

const startTimer = () => {
  if (props.duration > 0) {
    timer = setTimeout(() => {
      if (visible.value) {
        close();
      }
    }, props.duration);
  }
};

const clearTimer = () => {
  clearTimeout(timer);
};

const close = () => {
  visible.value = false;
  if (typeof props.onClose === "function") {
    props.onClose();
  }
};

watch(
  () => props.repeatNum,
  () => {
    clearTimer();
    startTimer();
  }
);

const customStyle = computed<CSSProperties>(() => ({
  top: `${props.offset}px`,
  zIndex: props.zIndex,
}));

onMounted(() => {
  startTimer();
  visible.value = true;
});

const handleStyle = (type?: string) => {
  if (
    type &&
    (type === TOAST_TYPE.ERROR ||
      type === TOAST_TYPE.SUCCESS ||
      type === TOAST_TYPE.WARNING)
  )
    return type;
  return TOAST_TYPE.NORMAL;
};

return { __sfc: true,props, visible, isH5, timer, onClose, startTimer, clearTimer, close, customStyle, handleStyle }
}

})